module.exports = __webpack_public_path__ + "static/media/Wurm_unlimited_Logo.6e5c2cab.png";